<template>
  <div style="width: 100%; padding: 20px;">
    <a-layout>
      <div class="warning" v-show="isAddOrEdit">
        <div style="position: absolute; top: 5px; right: 10px; cursor: pointer;" @click="cancel">
          <a-icon type="close" style="color: #fff; font-size: 24px;" />
        </div>
        <a-spin size="large" class="spin" v-show="isLoading"></a-spin>
        <div v-show="!isLoading">
          <a-form-model layout="inline" :model="form1" :rules="rules" ref="form1">
            <a-form-model-item :label="$t('device.warningName')" style="margin-right: 60px;" prop="name">
              <a-input v-model="form1.name" :placeholder="$t('warningForm.swmn')" style="width: 240px" />
            </a-form-model-item>
            <a-form-model-item :label="$t('menu.enabled')">
              <a-switch v-model="form1.enabled" :checked-children="$t('common.yes')"
                :un-checked-children="$t('common.no')" style="margin-top: 5px;" />
            </a-form-model-item>
          </a-form-model>
          <a-form-model :model="form2" ref="form2" :rules="rules">
            <a-form-model-item :label="$t('device.content')" prop="noticeContent">
              <a-input v-model="form2.noticeContent" :placeholder="$t('warningForm.encn')"></a-input>
            </a-form-model-item>
          </a-form-model>
          <a-form-model class="flex" :model="form3" :rules="rules" ref="form3">
            <a-form-model-item :label="$t('warningForm.noticeFrequency')" prop="noticeFrequency">
              <a-select v-model="form3.noticeFrequency" :placeholder="$t('warningForm.snf')"
                dropdownClassName="selectOption">
                <a-select-option :value="1">
                  1
                </a-select-option>
                <a-select-option :value="3">
                  3
                </a-select-option>
                <a-select-option :value="6">
                  6
                </a-select-option>
                <a-select-option :value="12">
                  12
                </a-select-option>
                <a-select-option :value="24">
                  24
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('warningForm.warningLevel')" prop="warningLevel">
              <a-select v-model="form3.warningLevel" :placeholder="$t('warningForm.swl')"
                dropdownClassName="selectOption">
                <a-select-option value="URGENT">
                  {{ $t('warningForm.URGENT') }}
                </a-select-option>
                <a-select-option value="IMPORTANT">
                  {{ $t('warningForm.IMPORTANT') }}
                </a-select-option>
                <a-select-option value="MINOR">
                  {{ $t('warningForm.MINOR') }}
                </a-select-option>
                <a-select-option value="PROMPT">
                  {{ $t('warningForm.PROMPT') }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('warningForm.effectiveTime')" required>
              <a-time-picker v-model="startTime" format="HH:mm"/>
              <span style="color: #fff; margin: 0 15px;">-</span>
              <a-time-picker v-model="endTime" format="HH:mm" />
            </a-form-model-item>
          </a-form-model>
          <a-form-model class="flex" :model="form3">
            <a-form-model-item :label="$t('warningForm.noticeCnt')" required>
              <a-input-number v-model="form3.noticeCnt" style="width: 80%;" />
            </a-form-model-item>
            <a-form-model-item :label="$t('warningForm.recoveryNotice')">
              <a-switch v-model="form3.recoveryNotice" :checked-children="$t('common.yes')"
                :un-checked-children="$t('common.no')" />
            </a-form-model-item>
            <div style="width: 96%;"></div>
          </a-form-model>
          <a-form-model :model="form4" :rules="rules" ref="form4">
            <a-form-model-item :label="$t('warningForm.warningRepeat')" prop="dayOfWeeks">
              <a-select :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="form4.dayOfWeeks" mode="tags" style="width: 100%; color: #fff" :placeholder="$t('warningForm.swr')" dropdownClassName="selectOption">
                <a-select-option value="SUNDAY">{{ $t('warningForm.Sunday') }}</a-select-option>
                <a-select-option value="MONDAY">{{ $t('warningForm.Monday') }}</a-select-option>
                <a-select-option value="TUESDAY">{{ $t('warningForm.Tuesday') }}</a-select-option>
                <a-select-option value="WEDNESDAY">{{ $t('warningForm.Wednesday') }}</a-select-option>
                <a-select-option value="THURSDAY">{{ $t('warningForm.Thursday') }}</a-select-option>
                <a-select-option value="FRIDAY">{{ $t('warningForm.Friday') }}</a-select-option>
                <a-select-option value="SATURDAY">{{ $t('warningForm.Saturday') }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('warningForm.description')" prop="description">
              <a-input :placeholder="$t('warningForm.ed')" v-model="form4.description"
                style="padding: 0 10px; color: #fff" />
            </a-form-model-item>
            <h3 class="tableTitle">{{ $t('warningForm.judgeCondition') }}: </h3>
            <a-button type="primary" @click="addExpressionParam">{{ $t('warningForm.addCondition') }}</a-button>
            <table class="formTable">
              <thead>
                <tr>
                  <th style="width: 500px;">{{ $t('configuration.device') }}</th>
                  <th style="width: 400px;">{{ $t('configuration.warningSettingTableParameter') }}</th>
                  <th>{{ $t('warningForm.monitorTime') }}</th>
                  <th>{{ $t('common.operation') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(e, i) in expressionParams" :key="e.id">
                  <td style="position: relative; width: 500px;">
                    <a-select v-model="e.deviceCode" :placeholder="$t('messages.selectDevice')"
                      dropdownClassName="selectOption" @change="getPointList(i)">
                      <a-select-option v-for="d in deviceList" :key="d.code">
                        {{ d.code }} - {{ d.name }} - {{ d.model }}
                      </a-select-option>
                    </a-select>
                  </td>
                  <td style="position: relative; width: 400px;">
                    <a-select v-model="e.pointCode" :placeholder="$t('placeholder.points')"
                      dropdownClassName="selectOption">
                      <a-select-option v-for="p in e.points" :key="p.code">
                        {{ p[lang] }}
                      </a-select-option>
                    </a-select>
                  </td>
                  <td style="position: relative;">
                    <a-select v-model="e.duration" :placeholder="$t('warningForm.sm')" dropdownClassName="selectOption">
                      <a-select-option v-for="(v, k) in duration" :key="k">
                        {{ v }}
                      </a-select-option>
                    </a-select>
                  </td>
                  <td>
                    <a-button type="link" @click="deleteExpressionParam(i)">{{ $t('buttons.delete') }}</a-button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="flex" style="margin-top: 30px;">
              <div style="width: 10%; display: flex; justify-content: space-between; align-items: center">
                <label style="color: #bfbfbf;">{{ $t('warningForm.judge') }}: </label>
                <a-select dropdownClassName="selectOption" style="width: 74%;" v-model="judge">
                  <a-select-option v-for="j in judgeList" :key="j">
                    {{ j }}
                  </a-select-option>
                </a-select>
              </div>
              <div style="width: 8%; display: flex; justify-content: space-between; align-items: center">
                <label style="color: #bfbfbf;">{{ $t('warningForm.value') }}: </label>
                <a-input-number v-model="value" style="width: 69%;" />
              </div>
              <div
                style="width: 76%; display: flex; justify-content: space-between; align-items: center; position: relative;"
                :class="{ error: isExpressionError }">
                <a-button type="primary" @click="generateExpression">{{ $t('warningForm.setExpression') }}</a-button>
              </div>
            </div>
            <div class="expression">
              <label style="color: #bfbfbf;">{{ $t('warningForm.expression') }}: </label>
              <div style="position: relative; width: 96%;">
                <a-textarea v-model="expressionStr" @blur="validateExpression" :auto-size="{ minRows: 2, maxRows: 6 }" style="color: #fff; padding: 0 10px;" />
                <span class="explain" v-show="isExpressionError">{{ $t('warningForm.ee') }}</span>
              </div>
            </div>
            <a-form-model-item style="margin-top: 30px;" :label="$t('warningForm.mobile')">
              <a-button type="primary" @click="addMobile">{{ $t('warningForm.addMobile') }}</a-button>
              <table class="formTable">
                <thead>
                  <tr>
                    <th>{{ $t('customer.realName') }}</th>
                    <th>{{ $t('warningForm.phoneNumber') }}</th>
                    <th>{{ $t('warningForm.userRole') }}</th>
                    <th>{{ $t('common.organization') }}</th>
                    <th>{{ $t('warningForm.SMSEnable') }}</th>
                    <th>{{ $t('warningForm.warningRecord') }}</th>
                    <th>{{ $t('common.operation') }}</th>
                  </tr>
                </thead>
                <tbody style="color: #ccc">
                  <tr v-for="(u, key) in userMap" :key="key">
                    <template v-if="u.editable">
                      <td style="width: 210px"><a-input @blur="f" style="width: 180px;" v-model="u.realName" /></td>
                      <td style="width: 210px"><a-input @blur="f" style="width: 190px" v-model="u.username" /></td>
                      <td style="width: 210px"><a-input @blur="f" style="width: 180px" v-model="u.roleName" /></td>
                      <td style="width: 210px"><a-input @blur="f" style="width: 180px" v-model="u.organizationName" />
                      </td>
                    </template>
                    <template v-else>
                      <td style="width: 210px">{{ u.realName }}</td>
                      <td style="width: 210px">{{ u.username }}</td>
                      <td style="width: 210px">{{ u.roleName }}</td>
                      <td style="width: 210px">{{ u.organizationName }}</td>
                    </template>
                    <td>
                      <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')" @change="f"
                        v-model="u.checked" />
                    </td>
                    <td>
                      <a-switch :checked-children="$t('common.open')" :un-checked-children="$t('common.close')"
                        @change="f" v-model="u.queryEnabled" />
                    </td>
                    <td>
                      <a href="javascript:;" @click="editM(u)">{{ u.editable ? $t('buttons.save') : $t('buttons.edit')
                        }}</a>
                      &nbsp;
                      &nbsp;
                      <a-popconfirm
                        style="padding: 0;"
                        :title="$t('messages.ctrd')"
                        :ok-text="$t('common.okText')"
                        :cancel-text="$t('common.cancelText')"
                        :disabled="u.disabled"
                        @confirm="removeU(u)"
                      >
                        <span :class="{ disabled: u.disabled }">{{ $t('buttons.delete') }}</span>
                      </a-popconfirm>
                    </td>
                  </tr>
                </tbody>
              </table>
            </a-form-model-item>
          </a-form-model>
          <a-form-model>
            <a-form-model-item>
              <a-button type="primary" @click="submit" :loading="btnLoading">
                {{ $t('buttons.save') }}
              </a-button>
              <a-button style="margin-left: 10px;" @click="cancel">
                {{ $t('common.cancelText') }}
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
      <a-layout-content v-show="!isAddOrEdit" style="background-color: #2f3d4f; padding: 20px; min-height: 770px"
        class="warning">
        <h3 class="header">
          {{ stationName }}
          <a-button v-if="isButtonShow" type="primary" style="float: right; margin-top: 15px" @click="showForm">{{
            $t('warningForm.add') }}</a-button>
        </h3>
        <table>
          <thead>
            <tr>
              <th>{{ $t('device.warningID') }}</th>
              <th>
                <div class="search">
                  {{ $t('device.warningName') }}
                  <a-input style="color: #fff; padding-left: 10px;" v-model="queryParams.name"
                    @keyup.enter="renderTable('')" />
                </div>
              </th>
              <th>
                <div class="search">
                  {{ $t('warningForm.description') }}
                  <a-input style="color: #fff; padding-left: 10px;" v-model="queryParams.description"
                    @keyup.enter="renderTable('')" />
                </div>
              </th>
              <th>
                <div class="search">
                  {{ $t('device.content') }}
                  <a-input style="color: #fff; padding-left: 10px;" v-model="queryParams.noticeContent"
                    @keyup.enter="renderTable('')" />
                </div>
              </th>
              <th>{{ $t('common.operation') }}</th>
            </tr>
          </thead>
          <tbody>
            <template v-show="!isLoading">
              <tr v-for="warning in warningTableList" :key="warning.id">
                <td>
                  {{ warning.id }}
                </td>
                <td>
                  {{ warning.name }}
                </td>
                <td>
                  {{ warning.description }}
                </td>
                <td class="content">
                  <span>{{ warning.noticeContent }}</span>
                </td>
                <td style="padding: 0 10px">
                  <a v-if="isButtonShow" href="javascript:;" @click="toggleToEdit(warning)">{{ $t('buttons.edit') }}</a>
                  &nbsp;
                  &nbsp;
                  <a-popconfirm style="padding: 0" :title="$t('messages.ctrd')" :ok-text="$t('common.okText')"
                    :cancel-text="$t('common.cancelText')" @confirm="removeWarning(warning.id)">
                    <a href="javascript:;">{{ $t('buttons.delete') }}</a>
                  </a-popconfirm>
                </td>
              </tr>
            </template>
            <tr v-if="warningTableList.length === 0">
              <td colspan="7" class="noData">{{ $t('device.empty') }}</td>
            </tr>
          </tbody>
        </table>
        <a-pagination show-less-items v-model="current" :pageSize="pageSize" :total="total" :hideOnSinglePage="true"
          @change="handlePageChange" />
        <a-spin size="large" class="spin" v-show="isLoading"></a-spin>
      </a-layout-content>
    </a-layout>
  </div>
</template>

<script>
import { nanoid } from "nanoid"
import {
  getCustomWarnings,
  postCustomWarning,
  putCustomWarning,
  getCustomWarning,
  deleteCustomWarning
} from "@/api/warning"
import { searchDeviceList } from "@/api/device"
import { getProtocol } from '@/api/protocol'
import { getCustomerById } from "@/api/customer"

import moment from "moment"

export default {
  data() {
    return {
      stationName: "多设备预警",
      isButtonShow: false,
      isLoading: true,
      warningTableList: [],
      dimension: {
        'DEVICE_STATUS': {
          zh: '设备状态',
          en: 'Device Status'
        },
        'DEVICE_PARAMETER': {
          zh: '设备参数',
          en: 'Device Parameter'
        },
        'STATION': {
          zh: '站房',
          en: 'station'
        }
      },
      current: 1,
      total: 0,
      pageSize: 10,
      queryParams: {
        name: "",
        description: "",
        noticeContent: ""
      },
      isAddOrEdit: false,
      form1: {
        name: "",
        enabled: false
      },
      form2: {
        noticeContent: ""
      },
      form3: {
        noticeFrequency: "",
        warningLevel: "",
        noticeCnt: 3,
        recoveryNotice: true
      },
      form4: {
        description: "",
        dayOfWeeks: undefined
      },
      startTime: moment('00:00', 'HH:mm'),
      endTime: moment('00:00', 'HH:mm'),
      rules: {
        name: [
          {
            required: true,
            message: this.$t('warningForm.swm'),
            trigger: 'blur'
          },
          {
            max: 20,
            message: this.$t('warningForm.n') + 20,
            trigger: 'blur'
          }
        ],
        noticeContent: [
          {
            required: true,
            message: this.$t('warningForm.enc'),
            trigger: 'blur'
          },
          {
            max: 120,
            message: this.$t('warningForm.n') + 120,
            trigger: 'blur'
          }
        ],
        noticeFrequency: [
          {
            required: true,
            message: this.$t('warningForm.snf')
          }
        ],
        warningLevel: [
          {
            required: true,
            message: this.$t('warningForm.swl')
          }
        ],
        dayOfWeeks: [
          {
            required: true,
            validator: this.validateDayOfWeeks
          }
        ]
      },
      isExpressionError: false,
      expressionParams: [],
      expressionStr: "",
      operators: ["+", "-", "*", "/"],
      deviceList: [],
      duration: {},
      judgeList: {
        EQ: '=',
        NE: '≠',
        GT: '>',
        GE: '≥',
        LT: '<',
        LE: '≤'
      },
      judge: ">",
      value: 5,
      userMap: {},
      btnLoading: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  created() {
    let a = this.getAuthorities('/equipment/group')
    this.isButtonShow = !!a.find(auth => auth.code === 'warning:custom:save')
  },
  mounted() {
    this.renderTable()
    this.getDeviceList()
    this.getCustomerInfo()
  },
  methods: {
    translate() {
      this.duration = {
        "5m": '5' + this.$t('warningForm.minutes'),
        "20m": '20' + this.$t('warningForm.minutes'),
        "60m": '60' + this.$t('warningForm.minutes')
      }
    },
    showForm() {
      this.isAddOrEdit = true
    },
    async toggleToEdit(r) {
      this.showForm()
      for (let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].clearValidate()
      }
      this.isLoading = true
      this.id = r.id
      try {
        const { data } = await getCustomWarning(r.id)
        for (let i = 0; i < 5; i++) {
          for (let key in this[`form${i}`]) {
            this[`form${i}`][key] = data[key]
          }
        }
        const time = data.effectiveTime || ["00:00", "00:00"]
        this.startTime = moment(time[0], 'HH:mm')
        this.endTime = moment(time[1], 'HH:mm')
        const regex = /fluxLast\(\#\{[^\}]+\}, '[^']+'\)/g
        this.expressionStr = data.expression
        const strs = data.expression.match(regex)
        const regexEP = /#{([a-zA-Z0-9_\.]+)\.([a-zA-Z0-9_]+)},\s*'([^']+)'/
        let m
        const promises = []
        this.expressionParams = strs.map((s, i) => {
          m = s.match(regexEP)
          promises.push(new Promise(async (resolve, reject) => {
            const device = this.deviceList.find(d => d.code === m[1])
            if (device) {
              try {
                const { data: { points } } = await getProtocol(device.protocolCode)
                this.expressionParams[i].points = points.filter(d => d.dataWrite !== 2).map(p => {
                  (p.details || []).forEach(d => {
                    if (d.locale === 'zh-CN') {
                      p.zh = d.name
                    }
                    if (d.locale === 'en-US') {
                      p.en = d.name
                    }
                  })
                  if (!p.zh) {
                    p.zh = p.name
                  }
                  if (!p.en) {
                    p.en = p.zh
                  }
                  return p
                })
                resolve()
              } catch (e) {
                console.log(e)
                reject(e)
              }
            }
          }))
          return {
            id: nanoid(),
            deviceCode: m[1],
            pointCode: m[2],
            duration: m[3],
            points: []
          }
        })
        const regexON = /([=≠><≤≥!]+)\s*(\d+(\.\d+)?)/
        const match = data.expression.match(regexON)
        if (match) {
          this.judge = match[1]
          this.value = match[2]
        }
        Promise.all(promises)
        data.mobiles.forEach(m => {
          const u = this.users.find(u => u.username === m.mobile)
          if (u) {
            this.userMap[u.id].checked = m.smsEnabled
            this.userMap[u.id].queryEnabled = m.queryEnabled
          } else {
            this.length++
            const id = nanoid()
            this.userMap[id] = {
              id,
              checked: m.smsEnabled,
              organizationName: m.organizationName,
              realName: m.name,
              roleName: m.roleName,
              username: m.mobile,
              disabled: false,
              queryEnabled: m.queryEnabled
            }
          }
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async removeWarning(id) {
      try {
        this.isLoading = true
        const { message } = await deleteCustomWarning(id)
        this.$message.success(message)
        this.renderTable()
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange(p) {
      this.current = p
      this.renderTable()
    },
    async renderTable(e) {
      try {
        this.isLoading = true
        if (e || e === "") {
          this.current = 1
        }
        const params = this.setSearchParams()
        const { data } = await getCustomWarnings(this.current, this.pageSize, params)
        this.warningTableList = data.records
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    setSearchParams() {
      const params = {
        query: [],
        filter: [
          {
            field: "customerId",
            value: this.$route.query.customerId || this.$route.query.ci
          }
        ],
        sort: []
      }
      let value
      for (let key in this.queryParams) {
        value = this.queryParams[key].trim()
        if (value) {
          params.query.push({
            field: key,
            value
          })
        }
      }
      return params
    },
    cancel() {
      this.isAddOrEdit = false
      for (let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].resetFields()
      }
      this.mobiles = []
      this.id = undefined
      this.form1.enabled = false
      this.form4.dayOfWeeks = undefined
      this.startTime = moment('00:00', 'HH:mm')
      this.endTime = moment('00:00', 'HH:mm')
      this.expressionParams = []
      this.expressionStr = ""
      this.getCustomerInfo()
    },
    addExpressionParam() {
      this.expressionParams.push({
        id: nanoid(),
        deviceCode: "",
        pointCode: "",
        duration: "",
        points: []
      })
    },
    async getDeviceList() {
      try {
        const { data } = await searchDeviceList(1, 1000, {
          query: [],
          filter: [
            {
              field: "customerId",
              value: this.$route.query.customerId || this.$route.query.ci
            }
          ]
        })
        this.deviceList = data.records
      } catch (e) {
        console.log(e)
      }
    },
    async getPointList(i) {
      try {
        if (this.expressionParams[i].deviceCode) {
          const device = this.deviceList.find(d => d.code === this.expressionParams[i].deviceCode)
          this.expressionParams[i].pointCode = ""
          if (device) {
            const { data: { points } } = await getProtocol(device.protocolCode)
            this.expressionParams[i].points = points.filter(d => d.dataWrite !== 2).map(p => {
              (p.details || []).forEach(d => {
                if (d.locale === 'zh-CN') {
                  p.zh = d.name
                }
                if (d.locale === 'en-US') {
                  p.en = d.name
                }
              })
              if (!p.zh) {
                p.zh = p.name
              }
              if (!p.en) {
                p.en = p.zh
              }
              return p
            })
          }
        }
      } catch (e) {
        console.log(e)
        this.expressionParams[i].points = []
      }
    },
    deleteExpressionParam(i) {
      this.expressionParams.splice(i, 1)
    },
    generateExpression() {
      if (this.expressionParams.length) {
        let ep = this.expressionParams[0]
        let result = "fluxLast(#{" + ep.deviceCode + "." + ep.pointCode + "}, '" + ep.duration + "') "
        for (let i = 1; i < this.expressionParams.length; i++) {
          ep = this.expressionParams[i]
          result += "+" + " fluxLast(#{" + ep.deviceCode + "." + ep.pointCode + "}, '" + ep.duration + "') "
        }
        this.expressionStr = result.trim() + " " + this.judge + " " + this.value
      } else {
        this.expressionStr = ""
      }

    },
    addMobile() {
      const id = nanoid()
      this.userMap[id] = {
        checked: false,
        id,
        organizationName: '',
        realName: '',
        roleName: '',
        username: '',
        editable: true,
        disabled: false
      }
      this.$forceUpdate()
    },
    f() {
      this.$forceUpdate()
    },
    async getCustomerInfo() {
      try {
        const { data } = await getCustomerById(this.$route.query.customerId || this.$route.query.ci)
        this.users = []
        const map = {}
        data.followers?.forEach(i => {
          i.roleName = this.$t('common.followers')
          i.checked = false
          i.disabled = true
          map[i.id] = i
        })
        data.salesmen?.forEach(i => {
          i.roleName = this.$t('common.salesMen')
          i.checked = false
          i.disabled = true
          map[i.id] = i
        })
        data.serviceMans?.forEach(i => {
          i.roleName = this.$t('common.serviceMen')
          i.checked = false
          i.disabled = true
          map[i.id] = i
        })
        data.users?.forEach(i => {
          i.roleName = this.$t('common.user')
          i.checked = false
          i.disabled = true
          map[i.id] = i
        })
        for (let key in map) {
          this.users.push(map[key])
        }
        this.userMap = map
      } catch (e) {
        console.log(e)
      }
    },
    editM(u) {
      u.editable = !u.editable
      this.$forceUpdate()
    },
    removeU(u) {
      if (u.disabled) return
      delete this.userMap[u.id]
      this.$forceUpdate()
    },
    async submit() {
      const flag = this.validate()
      if (flag) {
        this.btnLoading = true
        const effectiveTime = [moment(+this.startTime).format('HH:mm'), moment(+this.endTime).format('HH:mm')]
        const mobiles = []
        for (let key in this.userMap) {
          const k = this.userMap[key]
          mobiles.push({
            warningId: this.id,
            smsEnabled: !!k.checked,
            organizationName: k.organizationName,
            mobile: k.username,
            name: k.realName,
            roleName: k.roleName,
            queryEnabled: !!k.queryEnabled
          })
        }
        const params = {
          ...this.form1,
          ...this.form2,
          ...this.form3,
          ...this.form4,
          expression: this.expressionStr,
          mobiles,
          customerId: this.$route.query.customerId || this.$route.query.ci,
          effectiveTime,
        }
        try {
          if (this.id) {
            params.id = this.id
            const { message } = await putCustomWarning(params)
            this.$message.success(message)
          } else {
            const { message } = await postCustomWarning(params)
            this.$message.success(message)
          }
          this.cancel()
          this.renderTable()
        } catch (e) {
          console.log(e)
        } finally {
          this.btnLoading = false
        }
      } else {
        this.$message.warning(this.$t("configuration.pleaseCompleteForm"))
      }
    },
    validate() {
      let flag = true
      for (let i = 1; i < 5; i++) {
        this.$refs[`form${i}`].validate(valid => {
          flag = flag && valid
        })
      }
      flag = flag && this.validateExpression()
      return flag
    },
    validateExpression() {
      const replacedExpression = this.expressionStr.replace(/fluxLast\(\#\{[^\}]+\}, '([^\)]+)'\)/g, '0');

      try {
        // 使用 eval 来尝试执行替换后的表达式，验证其合法性
        eval(replacedExpression)
        this.isExpressionError = false
        return true
      } catch (e) {
        console.log(e)
        this.isExpressionError = true
        return false
      }
    },
    validateDayOfWeeks(_, value, callback) {
      if (value && value.length) {
        callback()
      } else {
        console.log("validateDayOfWeeks", value, !!(value && value.length))
        callback(new Error(this.$t('warningForm.swr')))
      }
    }
  }
}
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.ant-layout-has-sider {
  margin: 20px;
}

.header {
  width: 95%;
  margin: auto;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #F8FCED;
  border-bottom: 1px solid #1976CF;
}

.warning {
  position: relative;
  background-color: #2F3D4F;
  overflow: auto;
  min-height: 770px;

  tbody ul {
    width: 100%;

    li {
      padding: 0 10px;
      height: 30px;
      line-height: 30px;
    }

    li:hover {
      background-color: #A7ADB5;
    }
  }

  .device {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding-top: 20px;

    div {
      width: 48%;
      background-color: #212d3f;
    }

    .head {
      color: #f8fced;
      font-size: 18px;
      padding: 10px;
    }

    .border {
      width: 100%;
      clear: both;
      border-bottom: 1px solid #1976cf;
    }

    .body {
      width: 100%;
    }

    .body ul li {
      list-style: none;
      float: left;
      margin: 10px 0 10px 10px;
      padding: 0;
      width: 150px;
      /* overflow: hidden; */
      height: 24px;
      font-size: 16px;
      background-color: #4a90e2;
      color: #f8fced;
      text-align: center;

      .device_name {
        color: #fff;
        float: left;
        /* margin-left: 5px; */
        width: 120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      input[type^="checkbox"] {
        width: 18px;
        height: 18px;
        vertical-align: middle;
      }
    }
  }

  form {
    width: 90%;
    margin: 20px auto;

    input.ant-input {
      color: #fff;
      padding: 0 10px;
    }

    h3.tableTitle {
      font-size: 15px;
      color: #bfbfbf;
      margin-bottom: 15px;
    }

    input.ant-input {
      color: #fff;
      padding: 0 10px;
    }
  }

  .spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }

  .header {
    width: 95%;
    margin: auto;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    color: #F8FCED;
    border-bottom: 1px solid #1976CF;
  }

  table {
    width: 100%;
    border: 1px solid #4A5665;
    color: #A7ADB5;
    margin-top: 24px;
    margin-bottom: 24px;

    th,
    td {
      height: 60px;
      text-align: center;
    }

    thead td {
      height: 80px;
    }

    th {
      border-right: 1px solid #5B6574;
      background-color: #485464;
      padding: 0 10px;
    }

    td {
      border-top: 1px solid #445161;
      border-right: 1px solid #445161;

      &.content {
        width: 300px;
        overflow: hidden;
        box-sizing: border-box;

        span {
          display: block;
          max-width: 280px;
          padding-left: 10px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .formTable th,
  .formTable td {
    height: 40px;
  }

  .flex {
    display: flex;
    justify-content: space-between;

    .ant-form-item {
      width: 30%
    }
  }
}

.warning .ant-input,
.warning .ant-select-selection__placeholder.ant-input,
.warning .ant-calendar-picker-input.ant-input {
  background-color: #2F3D4F;
}

.warning .ant-input[data-v-020d5318],
.warning .ant-select-selection__placeholder.ant-input[data-v-020d5318],
.warning .ant-calendar-picker-input.ant-input[data-v-020d5318] {
  padding: 0 10px;
  color: #fff;
}

.ant-select-selection-selected-value {
  margin-left: 10px;
}

.error {
  input {
    border-color: #f5222d;
  }
}

.explain {
  position: absolute;
  color: #f5222d;
  bottom: 0;
  left: 0;
  transform: translate(0, 100%);
}

span.disabled {
  color: #999;
  cursor: not-allowed !important;
}

.formTable span:not(.disabled) {
  color: #1890ff;
  cursor: pointer;
}

.expression {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
</style>